<template>
  <div v-if="yhqlist && yhqlist.length > 0">
    <div
      class="yhq_tag"
      v-for="(yhq, yhq_index) in yhqlist"
      :key="yhq_index"
      @click="chooseitem(yhq, yhq_index)"
    >
      <div
        :class="
          `yhq_box ${chooseYhqIndex == yhq_index ? 'yhq_active' : ''} ${
            JiesuanJinE < yhq.youhuijine ? 'yhq_disabled' : ''
          }`
        "
      >
        <div class="yhq_left">
          <div class="yhq_price">
            <span class="yhq_CNY">￥</span><span>{{ yhq.youhuijine }}</span>
          </div>
        </div>
        <div class="yhq_right">
          <div class="yhq_text">{{ yhq.flag }}</div>
        </div>
        <div class="yhq_circle1"></div>
        <div class="yhq_circle2"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "yhqtag",
  props: ["yhqlist", "JiesuanJinE"],
  data() {
    return {
      chooseYhqIndex: -1
    };
  },

  created() {
    console.log(this.yhqlist);
  },
  methods: {
    chooseitem(yhq, index) {
      if (yhq.youhuijine > Number(this.JiesuanJinE)) return;
      console.log(yhq);
      this.chooseYhqIndex = index;

      this.$emit("chooseYhq", {
        title: yhq.flag,
        select: yhq.bjyouhuiquanxfid,
        close: false,
        index: index
      });
    },
    closeIndex() {
      this.chooseYhqIndex = -1;
    }
  }
};
</script>

<style lang="scss">
.yhq_tag {
  width: 190px;
  height: 60px;
  display: inline-block;
  margin-right: 20px;
  cursor: pointer;
  .yhq_box,
  .yhq_active {
    width: 190px;
    height: 60px;
    border-radius: 4px;
    background-color: #fff2f2;
    overflow: hidden;
    position: relative;
  }
  .yhq_left {
    width: 60px;
    height: 60px;
    float: left;
    /* background-color: yellow; */
    display: table;
    box-sizing: border-box;
    border-right: 2px dashed #fff;
  }
  .yhq_right {
    width: 130px;
    height: 60px;
    float: left;
    display: table;
    box-sizing: border-box;
  }
  .yhq_circle1 {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #fff;
    position: absolute;
    top: -5px;
    left: 55px;
  }
  .yhq_circle2 {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: absolute;
    background-color: #fff;
    bottom: -5px;
    left: 55px;
  }
  .yhq_text {
    /* position: absolute; */
    background-color: #fff2f2;
    color: #f56c6c;
    font-size: 12px;
    width: 100%;
    height: 16px;
    line-height: 1;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    /* top: 50%;
        margin-top: -8px; */
  }
  .yhq_price {
    background-color: #fff2f2;
    color: #f56c6c;
    font-size: 20px;
    width: 100%;
    text-align: center;
    /* height: 16px; */
    display: table-cell;
    vertical-align: middle;
    line-height: 1;
  }
  .yhq_CNY {
    font-size: 12px;
  }

  .yhq_active {
    background-color: #f56c6c !important;

    // border: 1px solid#f56c6c !important;
    .yhq_left {
      border-right: 2px dashed #fff !important;
    }
    .yhq_text {
      background-color: #f56c6c !important;
      color: #fff !important;
    }
    .yhq_price {
      background-color: #f56c6c !important;
      color: #fff !important;
    }
  }

  .yhq_disabled {
    opacity: 0.3 !important;
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/youhuiquan/yhqtag.vue